import {
  CLIENT_HEADER_ADMIN,
  CLIENT_HEADER_TEACHER,
  EAuthType,
  EForgotPasswordPageType,
} from '@configs'
import {
  IChangePasswordFields,
  ICommonDataResponse,
  ILoginFields,
  ILoginRequest,
  ILoginResponse,
  IResendCode,
  IResetPassword,
  IUserResponseLogin,
  IVerifyForgotPassword,
} from '@interfaces'
import { ApiClient } from './axiosClient'

const baseEndPoint = '/auth'

export const authAPI = {
  login: (values: ILoginRequest) => {
    return ApiClient.post<IUserResponseLogin, ILoginRequest>(
      `${baseEndPoint}/${EAuthType.LOGIN}`,
      values,
      {
        headers: {
          Client: `${CLIENT_HEADER_ADMIN},${CLIENT_HEADER_TEACHER}`,
        },
      }
    )
  },
  forgotPassword: (values: ILoginFields) => {
    return ApiClient.post<ILoginResponse, ILoginFields>(
      `${baseEndPoint}/${EForgotPasswordPageType.FORGOT_PASSWORD}`,
      values,
      {
        headers: {
          Client: `${CLIENT_HEADER_ADMIN},${CLIENT_HEADER_TEACHER}`,
        },
      }
    )
  },
  verifyPassword: (values: IVerifyForgotPassword) => {
    return ApiClient.post<ICommonDataResponse, IVerifyForgotPassword>(
      `${baseEndPoint}/${EForgotPasswordPageType.VERIFY_FORGOT_PASSWORD}`,
      values,
      {
        headers: {
          Client: `${CLIENT_HEADER_ADMIN},${CLIENT_HEADER_TEACHER}`,
        },
      }
    )
  },

  resendCode: (values: IResendCode) => {
    return ApiClient.post<ICommonDataResponse, IResendCode>(
      `${baseEndPoint}/${EForgotPasswordPageType.RESEND_CODE}`,
      values,
      {
        headers: {
          Client: `${CLIENT_HEADER_ADMIN},${CLIENT_HEADER_TEACHER}`,
        },
      }
    )
  },

  resetPassword: (values: IResetPassword) => {
    return ApiClient.post<{}, IResetPassword>(
      `${baseEndPoint}/${EForgotPasswordPageType.RESET_PASSWORD}`,
      values,
      {
        headers: {
          Client: `${CLIENT_HEADER_ADMIN},${CLIENT_HEADER_TEACHER}`,
        },
      }
    )
  },
  changePassword: (values: IChangePasswordFields) => {
    return ApiClient.post<{}, IChangePasswordFields>(
      `${baseEndPoint}/change-password`,
      values,
      {
        headers: {
          Client: `${CLIENT_HEADER_ADMIN},${CLIENT_HEADER_TEACHER}`,
        },
      }
    )
  },
  initPasswordAdmin: (values: IResetPassword) => {
    return ApiClient.post<{}, IResetPassword>(
      `${baseEndPoint}/init-password-admin`,
      values
    )
  },
}
